import Vue from "vue";
import VueI18n from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import { languages } from "./lang/lang";
import "./registerServiceworker";

Vue.config.productionTip = false;

const messages = Object.assign(languages);
const language = window.navigator.language.substr(0, 2);

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: language,
  fallbackLocale: "en",
  silentTranslationWarn: true,
  messages,
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
